export default __webpack_public_path__ + "static/replay-dark-mode-73ee909fe56a6e6bfae61edfacbb15a4.mp4";